import { render, staticRenderFns } from "./downloadApp.vue?vue&type=template&id=8e5f0b8e&scoped=true&"
import script from "./downloadApp.vue?vue&type=script&lang=js&"
export * from "./downloadApp.vue?vue&type=script&lang=js&"
import style0 from "./downloadApp.vue?vue&type=style&index=0&id=8e5f0b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5f0b8e",
  null
  
)

export default component.exports